// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import React, { FC, createRef, KeyboardEvent, useState, Fragment, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import type { FormInstance } from 'antd/es/form'
import { useHistory } from 'react-router-dom'
import { PageHeader, Space, Form, Input, Button, Typography, Select  } from 'antd'
import { HomeOutlined, BlockOutlined } from '@ant-design/icons'
import type { IAppState } from '@/store/reducers'
import Nav from '@/components/nav'

const arr = ['Services and Application', 'Software Architecture', 'Connectivity and BUS', 'PF&Control', 'Operating System', 'Cybersecurity&Safety', 'Electrical&Electronics', 'RF', 'Localization', 'Vision Display and Optics', 'Test technology', 'HMI', 'Sensors', 'Mechanics']

const Table1Edit: FC = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const tableEditData = useSelector((state: IAppState) => state.tableEditData.table1EditData)
    const route = useSelector((state: IAppState) => state.router)
    const formRef = createRef<FormInstance>()
    const { Text } = Typography
    const { Option } = Select

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 10 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 10 },
    }
    const onFinish = (values: any) => {
        console.log(values)
    }
    const onReset = () => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        formRef.current!.resetFields()
    }
    // const onYearChange = (e: string | number | null) => {
    //     console.log(e)
    // }
    // const onYearEnter = (e: KeyboardEvent<HTMLInputElement>) => {
    //     const target = e.target as HTMLInputElement
    //     console.log(target.value)
    //     setYears(Number(target.value))
    // }

    const routes = [
        {
            path: '/',
            breadcrumbName: '首页',
        },
        {
            path: '/keyRoadMap',
            breadcrumbName: 'Key Technology Roadmap',
        },
        {
            path: '/table1Edit',
            breadcrumbName: tableEditData.key ? '编辑' : '新增',
        },
    ]

    const labelArr = ['技术名称 Tech Name', '技术编号 PTN', '技术项目名 Project Info', '达成状态 Released']
    useEffect(() => {
        console.log(history.location, tableEditData, route)
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        formRef.current!.setFieldsValue(tableEditData)
    }, [history, route])
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageHeader className='router_nav'
                onBack={() => history.push('/keyRoadMap')}
                breadcrumb={{
                    routes, 
                    itemRender: (routeItem: any, params: any, routesParam: any) => {
                        const routeIndex = routesParam.indexOf(routeItem)
                        const last = routeIndex === routesParam.length - 1
                        return last ? (
                            <span>{routeItem.breadcrumbName}</span>
                        ) : (
                            <span className='ant-breadcrumb-link'
                                style={{ cursor: 'pointer', color: '#333' }} 
                                onClick={() => {
                                    history.replace(routeItem.path, route.location.state)
                                }}
                            >
                                <span className='anticon'>{routeIndex === 0 ? <HomeOutlined /> : <BlockOutlined />}</span>
                                <span>{routeItem.breadcrumbName}</span>
                            </span>
                        )
                    }
                }}
                title="返回列表"
            />
            <Form {...layout} ref={formRef} name="control-ref" onFinish={onFinish}
                className="edit_table"
            >
                <Form.Item label="编号">
                    <Space>
                        {tableEditData.key || 'Nodafk3432xxx'}
                        {!tableEditData.key && (<Text disabled style={{ fontSize: 12 }}>* 后台自动生成</Text>)}
                    </Space>
                </Form.Item>
                { !(history.location.pathname === '/table1Edit' && tableEditData.key) &&
                (<Form.Item name="workgroup" label="分组" rules={[{ required: true }]}>
                    <Select style={{ width: 220 }} placeholder='请选择分组'>
                        {
                            arr.map((item, index) => (<Option key={item} value={item} title={`WG${index + 1} ${item}`}>WG{index + 1} {item}</Option>))
                        }
                    </Select>
                </Form.Item>)
                }
                {
                    history.location.pathname === '/table1Edit' && tableEditData.key ? (
                        <Fragment key={tableEditData.key}>
                            <Form.Item {...tailLayout} className='label'>
                                {tableEditData.name}
                            </Form.Item>
                            <Form.Item name="workgroup" label='WORK GROUP/ROADMAP' rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                            {
                                Array(3).fill(1).map((_, index: number) => (
                                    <Form.Item key={index} name={`20${21 + index}`} label={`20${21 + index}`} 
                                        rules={[{ required: true }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                ))
                            }
                        </Fragment>
                    ) : (
                        labelArr.map(item => (
                            <Fragment key={item}>
                                <Form.Item {...tailLayout} className='label'>
                                    {item}
                                </Form.Item>
                                <Form.Item name="gender" label='WORK GROUP/ROADMAP' rules={[{ required: true }]}>
                                    <Input />
                                </Form.Item>
                                {
                                    Array(3).fill(1).map((_, index: number) => (
                                        <Form.Item key={index} name={`20${21 + index}`} label={`20${21 + index}`} 
                                            rules={[{ required: true }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    ))
                                }
                            </Fragment>
                        ))
                    )
                }
                <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                    <Space size={20}>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Reset
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Space>
    )
}

export default Table1Edit
